var blockquote_default = {
  "fontElementMap": "G-I9M",
  "quote": "SBWx-"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
